import React, { Component } from "react";
import styled from "styled-components";
import Aux from "../../hoc/Aux";
import Toolbar from "../Navgation/Toolbar/Toolbar";
import Sidedrawer from "../Navgation/Sidedrawer/Sidedrawer";
import Footer from "../Navgation/Footer/Footer";

const StyledMain = styled.main`
  margin-top: 8rem;
  height: 100vh;
  margin-bottom: 5rem;
`;
class Layout extends Component {
  state = {
    showSideDrawer: false
  };

  sideDrawerCloseHandler = () => {
    this.setState({ showSideDrawer: false });
  };

  sideDrawerToggleHandler = () => {
    this.setState(prevState => {
      return {
        showSideDrawer: !prevState.showSideDrawer
      };
    });
  };
  render() {
    return (
      <Aux>
        <Toolbar drawerToggleClicked={this.sideDrawerToggleHandler} />
        <Sidedrawer
          open={this.state.showSideDrawer}
          closed={this.sideDrawerCloseHandler}
        />
        <StyledMain>{this.props.children}</StyledMain>
        <Footer />
      </Aux>
    );
  }
}

export default Layout;



// WEBPACK FOOTER //
// ./src/components/Layout/Layout.js